































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { MessageService } from "@/shared/services/message-service";

@Component({ name: "PublicAgendaRequestsLogViewer" })
export default class PublicAgendaRequestsLogViewer extends Vue {
  public rows: any[] = [];
  public loading = false;

  public menuDesde = false;
  public menuHasta = false;

  public detalleOpen = false;
  public detalleItem: any = null;

  public filtro = {
    fechaDesde: null as string | null,
    fechaHasta: null as string | null,
    centroId: null as number | null,
    soloRechazadas: null as boolean | null,
    take: 200,
  };

  public opcionesRechazadas = [
    { text: "Todas", value: null },
    { text: "Solo rechazadas", value: true },
  ];

  public headers = [
    { text: "Fecha", value: "created_at", width: "160px" },
    { text: "Estado", value: "estado", width: "120px", sortable: false },
    { text: "Centro", value: "centro_id", width: "90px" },
    { text: "Servicio", value: "codigo_servicio" },
    { text: "Doctor", value: "doctor_id", width: "90px" },
    { text: "Rango", value: "rango", sortable: false },
    { text: "Limit", value: "limit_param", width: "80px" },
    { text: "IP", value: "ip" },
    { text: "", value: "acciones", sortable: false, align: "center", width: "50px" },
  ];

  public get validasCount(): number {
    return this.rows.filter((r) => !r.motivo_rechazo).length;
  }

  public get rechazadasCount(): number {
    return this.rows.filter((r) => !!r.motivo_rechazo).length;
  }

  public get porcentajeRechazo(): number {
    if (this.rows.length === 0) return 0;
    return Math.round((this.rechazadasCount / this.rows.length) * 100);
  }

  public mounted() {
    const hoy = new Date();
    const hace7 = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 7);
    this.filtro.fechaDesde = this.formatDate(hace7);
    this.filtro.fechaHasta = this.formatDate(hoy);
    this.cargarDatos();
  }

  public async cargarDatos() {
    this.loading = true;
    try {
      const params: string[] = [];
      if (this.filtro.fechaDesde) params.push(`fechaDesde=${this.filtro.fechaDesde}`);
      if (this.filtro.fechaHasta) params.push(`fechaHasta=${this.filtro.fechaHasta}`);
      if (this.filtro.centroId) params.push(`centroId=${this.filtro.centroId}`);
      if (this.filtro.soloRechazadas === true) params.push(`soloRechazadas=true`);
      if (this.filtro.take) params.push(`take=${this.filtro.take}`);
      const qs = params.length > 0 ? `?${params.join("&")}` : "";
      const data = await ssmHttpService.get(`${API.publicAgendaRequestsLog}${qs}`, null, false);
      this.rows = data || [];
    } catch (e) {
      MessageService.toast("Error cargando el log de peticiones", MessageService.TypeError);
    } finally {
      this.loading = false;
    }
  }

  public limpiarFiltros() {
    this.filtro = { fechaDesde: null, fechaHasta: null, centroId: null, soloRechazadas: null, take: 200 };
    this.cargarDatos();
  }

  public verDetalle(item: any) {
    this.detalleItem = item;
    this.detalleOpen = true;
  }

  public formatFecha(valor: string | null): string {
    if (!valor) return "—";
    const d = new Date(valor);
    if (isNaN(d.getTime())) return valor;
    return (
      d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) +
      " " +
      d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" })
    );
  }

  private formatDate(d: Date): string {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
}
